import type { FormQuestionOption, PublicationFormQuestion } from '~/interfaces/form';

interface Props {
  question: PublicationFormQuestion;
  questionOption: FormQuestionOption;
  checkedBoxes: number;
  setCheckedBoxes: (value: number) => void;
}

const MultipleChoiceInput = ({ question, questionOption, checkedBoxes, setCheckedBoxes }: Props) => {
  let isRequired = question.required;
  if (isRequired && question.multi_select && checkedBoxes > 0) {
    isRequired = false;
  }

  const handleCheck = (e: any) => {
    if (e.target.checked) {
      setCheckedBoxes(checkedBoxes + 1);
    } else {
      setCheckedBoxes(checkedBoxes - 1);
    }
  };

  return (
    <div className="flex items-center">
      <input
        id={questionOption.id}
        name={question.id}
        value={questionOption.value}
        type={question.multi_select ? 'checkbox' : 'radio'}
        required={isRequired}
        defaultChecked={false}
        className="h-5 w-5 cursor-pointer border-gray-300 text-wt-primary focus:ring-wt-primary"
        onChange={(e) => {
          handleCheck(e);
        }}
      />
      <label
        htmlFor={questionOption.id}
        className="text-md wt-body-font ml-3 block cursor-pointer font-semibold text-gray-700"
      >
        {questionOption.value}
      </label>
    </div>
  );
};

export default MultipleChoiceInput;
